import React from "react";

const AuthUserContext = React.createContext<any|null>(null);

export default AuthUserContext;
